import React from "react";

import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api"
import Types from "constants/Types";
import APPCONFIG from "constants/Config";
import {Button} from "reactstrap";
import {Collections} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import ObjectOverride from "components/ObjectOverride";
import FFLTextField from "components/Elements/FFLTextField";


/**
 *  @property {Importers_Object} state
 *  @property {object} model
 *  @property {Importers_Properties} model.properties
 *  @property {Importers_Is} model.is
 *  @property {Importers_Has} model.has
 */
export default class formSixPartOneObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Importers._name);
	}

	componentDidMount() {
		if(this.props.importer) {
			this.setState({
				name: this.props.importer.name ?? "",
				country_of_origin: this.props.importer.country_of_origin ?? "",
				full_address: this.props.importer.full_address ?? "",
				ffl_expiration: this.props.importer.ffl_expiration ?? "",
				ffl: this.props.importer.ffl ?? "",
				phone_number: this.props.importer.phone_number ?? "",
				foreign_shipper: this.props.importer.name ?? "",
				foreign_shipper_address: this.props.importer.full_address ?? "",
				foreign_seller: this.props.importer.name ?? "",
				foreign_seller_address: this.props.importer.full_address ?? ""
			})
		}

	}

	handleFormView = () => {
		window.open("https://www.atf.gov/firearms/docs/form/form-6-part-1-application-and-permit-importation-firearms-ammunition-and/download", "_blank");
	}

	handleSubmit = async() => {
		let imModel = new API.BuildClass(Types.Importers._name, API.RequestType.CREATE);
		this.request = 'PUT_FORM_6A';
		this.state.collection = this.props.collection;
		this.state.collection_binary_id = this.props.collection_binary_id;
		await imModel.submit(this, 'PUT_FORM_6A');
		this.props.afterSave();
		this.props.history.push('/acquisitions/'+this.props.collection_binary_id+'-'+this.props.collection+'#forms');
	}

	form = () => {
		/** @type {Importers_Properties} properties */
		let properties = this.model.properties;
		/** @type {Importers_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-md"}>
							{/*#region Importer Information*/}
							<h4 className="section-title">1. Importer Information</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"1a. Importer FFL"}
									property={properties.ffl}
									value={object.ffl}
									error={object.ffl_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group">
								<Framework.Elements.Date
									label={"1b. FFL Expiration"}
									property={properties.ffl_expiration}
									value={object.ffl_expiration}
									error={object.ffl_expiration_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<h4 className="section-title">2. Telephone No.</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Phone Number"}
									property={properties.phone_number}
									value={object.phone_number}
									error={object.phone_number_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>


							<h4 className="section-title">3. Country of Exportation</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Country Of Exportation"}
									property={properties.country_of_origin}
									value={object.country_of_origin}
									error={object.country_of_origin_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>


							{/*#endregion*/}

							{/*#region Customers Broker*/}
							<h4 className="section-title" style={{position: 'relative'}}>
								4. Name and Address of Customs Broker
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Customs Broker"}
									property={properties.customs_broker}
									value={object.customs_broker}
									error={object.customs_broker_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>


							<div className="form-group">
								<Framework.Elements.TextField
									label={"Custom's Broker Full Address"}
									property={properties.customs_broker_address}
									value={object.customs_broker_address}
									error={object.customs_broker_address_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<h4 className="section-title">
								Check Yes if Permit is to be returned to customs broker
							</h4>
							<div className="form-group">
								<Framework.Elements.ButtonSwitch
									label={"Return to Customs Broker"}
									property={properties.return_customs_broker}
									value={object.return_customs_broker}
									error={object.return_customs_broker_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}

							{/*#region Contact Information*/}
							<h4 className="section-title">
								5. Applicant's Name and Address
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Applicant's Name"}
									property={properties.applicant}
									value={object.applicant}
									error={object.applicant_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Applicant's Full Address"}
									property={properties.applicant_address}
									value={object.applicant_address}
									error={object.applicant_address_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#region Contact Information*/}
							<h4 className="section-title">
								Check Yes if Permit is to be returned to applicant
							</h4>
							<div className="form-group">
								<Framework.Elements.ButtonSwitch
									label={"Return to Applicant"}
									property={properties.return_applicant}
									value={object.return_applicant}
									error={object.return_applicant_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>


							<h4 className="section-title" style={{position: 'relative'}}>
								6. Name and Address of Foreign Seller, if any
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Foreign Seller's Name"}
									property={properties.foreign_seller}
									value={object.foreign_seller}
									error={object.foreign_seller_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>


							<div className="form-group">
								<Framework.Elements.TextField
									label={"Foreign Seller's Full Address"}
									property={properties.foreign_seller_address}
									value={object.foreign_seller_address}
									error={object.foreign_seller_address_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							{/*#endregion*/}
							{/*#region Federal Firearms License*/}
						</div>
						<div className={"col-md"}>
							{/*#endregion*/}
							{/*#region Federal Firearms License*/}
							<h4 className="section-title" style={{position: 'relative'}}>
								7. Name and Address of Foreign Shipper
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Foreign Shipper's Name"}
									property={properties.foreign_shipper}
									value={object.foreign_shipper}
									error={object.foreign_shipper_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Foreign Shipper's Full Address"}
									property={properties.foreign_shipper_address}
									value={object.foreign_shipper_address}
									error={object.foreign_shipper_address_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<h4 className="section-title" style={{position: 'relative'}}>
								10. Specific Purpose of Importation, Including Final Recipient, If Known
							</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Purpose of Importation"}
									property={properties.purpose_of_importation}
									value={object.purpose_of_importation}
									error={object.purpose_of_importation_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<h4 className="section-title" style={{position: 'relative'}}>
								11. Are You Registered as an Importer Pursuant to The Tax Arms Export
							</h4>
							<div className="form-group">
								<Framework.Elements.ButtonSwitch
									label={"registered_pursuant"}
									property={properties.registered_pursuant}
									value={object.registered_pursuant}
									error={object.registered_pursuant_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<h4 className="section-title" style={{position: 'relative'}}>
								12. If "Yes" Give Importer's Registration No. And Expiration Date
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Importer Registration Number and Expiration"}
									property={properties.registration_expiration}
									value={object.registration_expiration}
									error={object.registration_expiration_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<h4 className="section-title" style={{position: 'relative'}}>
								13. Name of Applicant
							</h4>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Applicant Name"}
										property={properties.applicant}
										value={object.applicant}
										error={object.applicant_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							<h4 className="section-title" style={{position: 'relative'}}>
								14. Signature of Applicant (note: this will grab the account signature on file)
							</h4>
							<div className="form-group">
								<Framework.Elements.ButtonSwitch
									label={"registered_pursuant"}
									property={properties.signature_of_applicant}
									value={object.signature_of_applicant}
									error={object.signature_of_applicant_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<h4 className="section-title" style={{position: 'relative'}}>
								15. Title
							</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Title"}
									property={properties.applicant_title}
									value={object.applicant_title}
									error={object.applicant_title_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<h4 className="section-title" style={{position: 'relative'}}>
								16. Date
							</h4>
							<div className="form-group">
								<Framework.Elements.Date
									label={"Date"}
									property={properties.date_in}
									value={object.date_in}
									error={object.date_in_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
								<div>
							</div>
							<div>

								<Button data-id="previous-product" onClick={this.handleFormView} size={"sm"}
								        color="info">
									<i className={"fa fa-barcode"}/>
									<span className="hidden-xs">&nbsp;&nbsp;View Form</span>
								</Button>
							</div>

						</div>
					{/*<div className="col-md">*/}

						{/*<h4 className="section-title" style={{position: 'relative'}}>*/}
						{/*	Defense Articles*/}
						{/*</h4>*/}

						{/*<div className="form-group">*/}
						{/*	<Framework.Elements.TextField*/}
						{/*		label={"Manufacturer Name"}*/}
						{/*		property={properties.defense_articles_manufacturer_name}*/}
						{/*		value={object.defense_articles_manufacturer_name}*/}
						{/*		error={object.defense_articles_manufacturer_name_error}*/}
						{/*		update={this.handleTextFieldPropertyUpdate}*/}
						{/*	/>*/}
						{/*</div>*/}

						{/*<div className="form-group">*/}
						{/*	<Framework.Elements.TextField*/}
						{/*		label={"Manufacturer City/State or City/Country"}*/}
						{/*		property={properties.defense_articles_manufacturer_address}*/}
						{/*		value={object.defense_articles_manufacturer_address}*/}
						{/*		error={object.defense_articles_manufacturer_address_error}*/}
						{/*		update={this.handleTextFieldPropertyUpdate}*/}
						{/*	/>*/}
						{/*</div>*/}


						{/*<div className="form-group">*/}
						{/*	<Framework.Elements.TextField*/}
						{/*		label={"Caliber Gauge or Size"}*/}
						{/*		property={properties.defense_articles_caliber}*/}
						{/*		value={object.defense_articles_caliber}*/}
						{/*		error={object.defense_articles_caliber_error}*/}
						{/*		update={this.handleTextFieldPropertyUpdate}*/}
						{/*	/>*/}
						{/*</div>*/}

						{/*<div className="form-group">*/}
						{/*	<Framework.Elements.TextField*/}
						{/*		label={"Quantity (Each type)"}*/}
						{/*		property={properties.defense_articles_quantity}*/}
						{/*		value={object.defense_articles_quantity}*/}
						{/*		error={object.defense_articles_quantity_error}*/}
						{/*		update={this.handleTextFieldPropertyUpdate}*/}
						{/*	/>*/}
						{/*</div>*/}
						{/*<div className="form-group">*/}
						{/*	<Framework.Elements.TextField*/}
						{/*		label={"Unit Cost (U.S. Currency)"}*/}
						{/*		property={properties.defense_articles_unit}*/}
						{/*		value={object.defense_articles_unit}*/}
						{/*		error={object.defense_articles_unit_error}*/}
						{/*		update={this.handleTextFieldPropertyUpdate}*/}
						{/*	/>*/}
						{/*</div>*/}

						{/*<div className="form-group">*/}
						{/*	<Framework.Elements.TextField*/}
						{/*		label={"U.S. Munitions Import List Category"}*/}
						{/*		property={properties.defense_articles_munitions}*/}
						{/*		value={object.defense_articles_munitions}*/}
						{/*		error={object.defense_articles_munitions_error}*/}
						{/*		update={this.handleTextFieldPropertyUpdate}*/}
						{/*	/>*/}
						{/*</div>*/}
							{/*<h4 className="section-title" style={{position: 'relative'}}>*/}
							{/*	Ammunition*/}
							{/*</h4>*/}

							{/*<div className="form-group">*/}
							{/*	<Framework.Elements.TextField*/}
							{/*		label={"Manufacturer Name"}*/}
							{/*		property={properties.ammunition_manufacturer_name}*/}
							{/*		value={object.ammunition_manufacturer_name}*/}
							{/*		error={object.ammunition_manufacturer_name_error}*/}
							{/*		update={this.handleTextFieldPropertyUpdate}*/}
							{/*	/>*/}
							{/*</div>*/}

							{/*<div className="form-group">*/}
							{/*	<Framework.Elements.TextField*/}
							{/*		label={"Manufacturer City/State or City/Country"}*/}
							{/*		property={properties.ammunition_manufacturer_address}*/}
							{/*		value={object.ammunition_manufacturer_address}*/}
							{/*		error={object.ammunition_manufacturer_address_error}*/}
							{/*		update={this.handleTextFieldPropertyUpdate}*/}
							{/*	/>*/}
							{/*</div>*/}


							{/*<div className="form-group">*/}
							{/*	<Framework.Elements.TextField*/}
							{/*		label={"Caliber Gauge or Size"}*/}
							{/*		property={properties.ammunition_caliber}*/}
							{/*		value={object.ammunition_caliber}*/}
							{/*		error={object.ammunition_caliber_error}*/}
							{/*		update={this.handleTextFieldPropertyUpdate}*/}
							{/*	/>*/}
							{/*</div>*/}

							{/*<div className="form-group">*/}
							{/*	<Framework.Elements.TextField*/}
							{/*		label={"Quantity (Each type)"}*/}
							{/*		property={properties.ammunition_quantity}*/}
							{/*		value={object.ammunition_quantity}*/}
							{/*		error={object.ammunition_quantity_error}*/}
							{/*		update={this.handleTextFieldPropertyUpdate}*/}
							{/*	/>*/}
							{/*</div>*/}
							{/*<div className="form-group">*/}
							{/*	<Framework.Elements.TextField*/}
							{/*		label={"Unit Cost (U.S. Currency)"}*/}
							{/*		property={properties.ammunition_unit}*/}
							{/*		value={object.ammunition_unit}*/}
							{/*		error={object.ammunition_unit_error}*/}
							{/*		update={this.handleTextFieldPropertyUpdate}*/}
							{/*	/>*/}
							{/*</div>*/}

							{/*<div className="form-group">*/}
							{/*	<Framework.Elements.TextField*/}
							{/*		label={"U.S. Munitions Import List Category"}*/}
							{/*		property={properties.ammunition_munitions}*/}
							{/*		value={object.ammunition_munitions}*/}
							{/*		error={object.ammunition_munitions_error}*/}
							{/*		update={this.handleTextFieldPropertyUpdate}*/}
							{/*	/>*/}
							{/*</div>*/}
						{/*</div>*/}
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
